import { ko } from 'date-fns/locale/ko';
import { decodeHTML } from 'entities';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useSearchParams } from 'react-router-dom';
import { getMAGAA000, postMAGAF010, putMAGAA000 } from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_CENTER } from '../../../shared/constants/app';
import CheckGroup from '../../../shared/components/CheckGroup';
import { formatDate, formatNumberWithCommas, getCheckBoxValues } from '../../../utils';
registerLocale('ko', ko);

const MAGAF010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [display, setDisplay] = useState('N');
    const [searchCondition, setSearchCondition] = useState('A');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [checkedValues, setCheckedValues] = useState({});

    const noticeChecked = Array.isArray(checkedValues.Notice) && checkedValues.Notice.includes('Y');
    const contentViewChecked = Array.isArray(checkedValues.ContentView) && checkedValues.ContentView.includes('Y');


    // build options object

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const freshDisplay = () => {
        getMAGAA000('pahaf010')
            .then(({ data }) => {
                setDisplay(data.display);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        freshDisplay();
    }, []);

    const handleChangeDisplay = async (e) => {
        // const newDisplay = display === 'Y' ? 'N' : 'Y';
        try {
            await putMAGAA000('pahaf010');
            freshDisplay();
        } catch (error) {
            console.log(error);
        }
    };

    const getStatusText = (startDate, endDate) => {
        const now = new Date();

        const start = new Date(startDate);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999);

        if (now >= start && now <= end) {
            return '게재중';
        } else if (now < start) {
            return '게재예정';
        } else {
            return '마감';
        }
    };

    const getSearchCondition = (e) => {
        const selectedValue = e.target.value;
        setSearchCondition(selectedValue);
    };
    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const getTargetDisplay = (target) => {
        switch (target) {
            case 'A':
                return '전체회원';
            case 'C':
                return '치과회원';
            case 'P':
                return '개인회원';
            default:
                return '';
        }
    };

    const getGubun = (gubun) => {
        switch (gubun) {
            case '01':
                return '공지';
            case '02':
                return '소식';
            default:
                return '';
        }
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;
        setCheckedValues((checkedValues) => getCheckBoxValues(checkedValues, name, value, checked));
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postMAGAF010({
            page: currentPage,
            options: {
                Target: searchCondition === 'A' ? ['A', 'P', 'C'] : [searchCondition],
                ...(noticeChecked ? { Notice: ['Y'] } : {}),
                ...(contentViewChecked ? { ContentView: ['Y'] } : {}),
            },
            keyword: keyword?.trim(),
            startDate: startDateFormated,
            endDate: endDateFormated,
        })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            clickSearch();
        }
    };

    const clickReset = () => {
        setSearchParams('');
        setSearchCondition('A');
        setKeyword('');
        setStartDate('');
        setEndDate('');
        setDateRate('');
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    return (
        <div className="list-of-dental-journals container">
            <div className="wrap">
                <SideMenu menu={MENU_CENTER} />
                <div className="list-of-dental-journals-content content-right">
                    <h1 className="title">공지/소식</h1>
                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>대상</th>
                                    <td>
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="A">전체회원</option>
                                                <option value="P">개인회원</option>
                                                <option value="C">치과 회원</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="검색어 입력"
                                                onChange={inputChange}
                                                value={keyword}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </td>

                                    <th style={{ borderBottom: '1px solid #ddd' }}>상단공지</th>
                                    <td>
                                        <div className="flex-CheckGroup">
                                            <CheckGroup
                                                name="Notice"
                                                options={[
                                                    { id: 'Notice', value: 'Y', label: '설정' }
                                                ]}
                                                checkedValues={checkedValues.Notice}
                                                onChange={handleCheckboxChange}
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>


                                    <th style={{ borderBottom: '1px solid #ddd' }}>내용같이</th>
                                    <td>
                                        <div className="flex-CheckGroup">
                                            <CheckGroup
                                                name="ContentView"
                                                options={[
                                                    { id: 'ContentView', value: 'Y', label: '설정' }
                                                ]}
                                                checkedValues={checkedValues.ContentView}
                                                onChange={handleCheckboxChange}
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록일</th>
                                    <td colSpan={7}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>메뉴 표시</th>
                                    <td>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={handleChangeDisplay}
                                                checked={display === 'Y'}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>

                    <div className="button-item">
                        <Link to={'/magaf020'}>공지 등록</Link>
                    </div>

                    <div className="results">
                        <div className="count-item">
                            총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                        </div>
                        <table className="table-gray">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>구분</th>
                                    <th style={{ width: '45%' }}>제목</th>
                                    <th>상태</th>
                                    <th>상단공지</th>
                                    <th>내용같이보기</th>
                                    <th>대상</th>
                                    <th>조회수</th>
                                    <th>등록일</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{item.seq}</td>
                                                <td>
                                                    <span
                                                        className={`status ${item?.gubun === '01'
                                                            ? 'blue'
                                                            : item?.gubun === '02'
                                                                ? 'green'
                                                                : ''
                                                            } `}
                                                    >
                                                        {getGubun(item?.gubun)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <Link to={`/magaf030-${item.seq}`}>{decodeHTML(item.title)}</Link>
                                                </td>
                                                <td>{getStatusText(item.startDate, item.endDate)}</td>
                                                <td>{item?.notice === 'Y' ? '예' : ''}</td>
                                                <td>{item?.contentView === 'Y' ? '예' : ''}</td>
                                                <td>{getTargetDisplay(item?.target)}</td>
                                                <td>{formatNumberWithCommas(item?.visitedCnt)}</td>
                                                <td>{formatDate(item?.addDate)}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={9}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MAGAF010;
